module.exports = __webpack_public_path__ + "media/images/icons/instructions-d620ae05c93d40eca1a3d14d1e1f16db.svg";